export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Absolutne": "Absolute",
        "Adres": "Address",
        "Adres email": "Email address",
        "Ai": "Ai",
        "Aktualna karta": "Current tab",
        "Aktualne selektory dla których wyświetlane i edytowane są style": "Current selectors for which styles are displayed and edited",
        "Aktywne": "Active",
        "Angielski": "English",
        "Animacje": "Animations",
        "Anuluj": "Cancel",
        "Arkusz styli": "Stylesheet",
        "Arkusze styli": "Stylesheets",
        "Auto": "Auto",
        "Automatyczna": "Automatic",
        "Automatyczne odtwarzanie": "Autoplay",
        "Bez limitu": "No limit",
        "Biblioteka": "Library",
        "Blok": "Block",
        "Blok nie został usunięty": "Block has not been deleted",
        "Blok został usunięty": "Block has been deleted",
        "Blok został zaktualizowany": "Block has been updated",
        "Blok został zapisany": "Block has been saved",
        "Blur": "Blur",
        "Błąd podczas dodawania urządzenia": "Error while adding device",
        "Błędna szerokość": "Invalid width",
        "brak": "none",
        "Brak": "None",
        "Brak animacji": "No animation",
        "Brak limitu": "No limit",
        "Cały tekst małą literą": "All lowercase",
        "Cały tekst wielką literą": "All uppercase",
        "Checkbox": "Checkbox",
        "Cień": "Shadow",
        "Cofnij": "Undo",
        "CSS": "CSS",
        "Cytat": "Quote",
        "Czas trwania": "Duration",
        "Czas trwania (ms)": "Duration (ms)",
        "Czas trwania zmiany styli (transition)": "Style change duration (transition)",
        "Czcionka": "Font",
        "Czcionki": "Fonts",
        "Czy na pewno chcesz usunąć to urządzenie?": "Are you sure you want to delete this device?",
        "Dekoracja": "Decoration",
        "Do lewej": "Left",
        "Do prawej": "Right",
        "Dodaj": "Add",
        "Dodaj klasę": "Add class",
        "Dodaj kolejną klasę": "Add another class",
        "Dodaj kolejną opcję": "Add another option",
        "Dodaj kolejny arkusz styli": "Add another stylesheet",
        "Dodaj kolejny skrypt": "Add another script",
        "Dodaj kolor": "Add color",
        "Dodaj niestandardowe urządzenie": "Add custom device",
        "Dodaj nowy element listy": "Add new list item",
        "Dodaj nowy slajd": "Add new slide",
        "Dodaj szablon": "Add template",
        "Dodatkowy element": "Additional element",
        "Dolny": "Bottom",
        "Domyślny": "Default",
        "Dostępne klasy": "Available classes",
        "Duplikuj": "Duplicate",
        "Duży komputer": "Large desktop",
        "Duży telefon": "Large phone",
        "Dwie kolumny w wierszu": "Two columns in row",
        "Dziedziczona": "Inherited",
        "ease": "ease",
        "ease-in": "ease-in",
        "ease-in-out": "ease-in-out",
        "ease-out": "ease-out",
        "Edycja": "edit",
        "Edytor kodu CSS": "CSS code editor",
        "Edytor kodu HTML": "HTML code editor",
        "Edytor kodu JavaScript": "JavaScript code editor",
        "Edytor kodu Vue": "Vue code editor",
        "Edytor komponentu React": "React component editor",
        "Edytuj": "Edit",
        "Edytuj kod CSS": "Edit CSS code",
        "Edytuj kod HTML": "Edit HTML code",
        "Edytuj kod JavaScript": "Edit JavaScript code",
        "Edytuj kod Vue": "Edit Vue code",
        "Edytuj komponent React": "Edit React component",
        "Edytuj style": "Edit styles",
        "Efekty": "Effects",
        "Ekran jest za mały aby korzystać z kreatora stron": "Screen is too small to use page builder",
        "Element klikalny": "Clickable element",
        "Element listy": "List item",
        "Elementy": "Elements",
        "Etykieta": "Label",
        "Film": "Video",
        "Film YouTube": "YouTube video",
        "Filtr": "Filter",
        "Filtr tła": "Background filter",
        "Flex": "Flex",
        "Formularz": "Form",
        "Francuski": "French",
        "Funkcja": "Function",
        "Generuj tekst": "Generate text",
        "Globalna klasa": "Global class",
        "Globalne kolory": "Global colors",
        "Górny": "Top",
        "Gradient": "Gradient",
        "Gradient promieniowy": "Radial gradient",
        "Grid": "Grid",
        "Gruba": "Bold",
        "Grubość obramowania": "Border width",
        "Grubość tekstu": "Font weight",
        "Hover": "Hover",
        "Id inputa": "Input ID",
        "Ikona": "Icon",
        "Indeksowanie": "Indexing",
        "Indeksuj": "Index",
        "Indykatory": "Indicators",
        "Indykatory poza sliderem": "Indicators outside slider",
        "Italic": "Italic",
        "Jasność": "Brightness",
        "Język": "Language",
        "Klasy": "Classes",
        "Kliknij aby wybrać tą czcionkę": "Click to select this font",
        "Kod": "Code",
        "Kod nie może być pusty": "Code cannot be empty",
        "Kod strony": "Page code",
        "Kod svg": "SVG code",
        "Kolor": "Color",
        "Kolor obramowania": "Border color",
        "Kolor strzałek": "Arrow color",
        "Kolor tekstu": "Text color",
        "Kolor wypełnienia indykatorów": "Indicator fill color",
        "Kolory": "Colors",
        "Kolumna": "Column",
        "Kolumny": "Columns",
        "Koło": "Circle",
        "Komputer": "Desktop",
        "Kontener": "Container",
        "Kontrast": "Contrast",
        "Kontrolki playera": "Player controls",
        "Krok": "Step",
        "Kursor": "Cursor",
        "Kwadrat": "Square",
        "Label": "Label",
        "Label dla inputa": "Label for input",
        "Laptop": "Laptop",
        "Lepkie": "Sticky",
        "Lewy": "Left",
        "Lewy dolny": "Bottom left",
        "Lewy dolny róg": "Bottom left corner",
        "Lewy górny": "Top left",
        "Lewy górny róg": "Top left corner",
        "Liczba widocznych slajdów": "Number of visible slides",
        "Liczby dziesiętne": "Decimal numbers",
        "Liczby rzymskie": "Roman numerals",
        "linear": "linear",
        "Linia ciągła": "Solid line",
        "Linia kropkowana": "Dotted line",
        "Linia u dołu tekstu": "Underline",
        "Linia u góry tekstu": "Overline",
        "Linia wycentrowana": "Line through",
        "Link": "Link",
        "Link do filmu YouTube": "YouTube video link",
        "LinkBox": "LinkBox",
        "Lista": "List",
        "Lista nienumerowana": "Unordered list",
        "Lista numerowana": "Ordered list",
        "Maks. szerokość": "Max. width",
        "Maks. wysokość": "Max. height",
        "Maksymalna szerokość": "Maximum width",
        "Maksymalna szerokość w px": "Maximum width in px",
        "Mały tablet": "Small tablet",
        "Mały telefon": "Small phone",
        "Mapa": "Map",
        "Margines": "Margin",
        "Menadżer urządzeń": "Device manager",
        "Metoda": "Method",
        "Min. szerokość": "Min. width",
        "Min. wysokość": "Min. height",
        "Motywy": "Themes",
        "Nagłówek": "Heading",
        "Nagłówek 1": "Heading 1",
        "Nagłówek 2": "Heading 2",
        "Nagłówek 3": "Heading 3",
        "Nagłówek 4": "Heading 4",
        "Nagłówek 5": "Heading 5",
        "Narzędzia AI": "AI tools",
        "Następny slajd": "Next slide",
        "Nawigacja": "Navigation",
        "Nazwa": "Name",
        "Nazwa klasy": "Class name",
        "Nazwa koloru": "Color name",
        "Nazwa koloru jest wymagana": "Color name is required",
        "Nazwa koloru już istnieje": "Color name already exists",
        "Nazwa musi mieć minimum 2 znaki": "Name must have at least 2 characters",
        "Nazwa nie może być pusta": "Name cannot be empty",
        "Nazwa skryptu": "Script name",
        "Nazwa szablonu": "Template name",
        "Nazwa urządzenia": "Device name",
        "Nie indeksuj": "Do not index",
        "Nie posiadasz uprawnień aby zapisać komponent": "You do not have privileges to save component",
        "Nie posiadasz uprawnień do dodania nowego motywu": "You do not have privileges to add new theme",
        "Nie posiadasz uprawnień do edycji zapisanego komponentu": "You do not have privileges to edit saved component",
        "Nie posiadasz uprawnień do usunięcia motywu": "You do not have privileges to delete theme",
        "Nie posiadasz uprawnień do usunięcia zapisanego komponentu": "You do not have privileges to delete saved component",
        "Nie powtarzaj": "Do not repeat",
        "Nie udało się pobrać bloków": "Failed to fetch blocks",
        "Nie udało się pobrać definicji bloku": "Failed to fetch block definition",
        "Nie udało się pobrać szablonów": "Failed to fetch templates",
        "Nie udało się wygenerować tekstu": "Failed to generate text",
        "Nie udało się zaktualizować bloku": "Failed to update block",
        "Nie udało się zapisać bloku": "Failed to save block",
        "Nie wyświetlaj": "Do not display",
        "Nie zawijaj": "Do not wrap",
        "Niemiecki": "German",
        "Nienumerowana": "Unordered",
        "Nieparzysty element": "Odd element",
        "Nieprawidłowy format koloru": "Invalid color format",
        "Nieruchome": "Fixed",
        "Niestandardowe": "Custom",
        "Normalna": "Normal",
        "Nowa karta": "New tab",
        "np. checkbox-1": "e.g. checkbox-1",
        "np. https://ideo.pl": "e.g. https://ideo.pl",
        "np. Jan": "e.g. Jan",
        "np. Nad przyrwą 13": "e.g. Nad przyrwą 13",
        "np. radio-1": "e.g. radio-1",
        "np. Tekst opisowy": "e.g. Descriptive text",
        "np. Twoje imie": "e.g. Your name",
        "Numerowana": "Ordered",
        "Obetnij nadmiar": "Clip overflow",
        "Obramowanie": "Border",
        "Obrót odcieni": "Hue rotate",
        "Odepnij": "Detach",
        "Odległość między elementami": "Gap between elements",
        "Odległość między slajdami (px)": "Gap between slides (px)",
        "Odległość od dolnej krawędzi": "Distance from bottom edge",
        "Odległość od górnej krawędzi": "Distance from top edge",
        "Odległość z lewej strony": "Distance from left side",
        "Odległość z prawej strony": "Distance from right side",
        "Odstęp dookoła elementów": "Spacing around elements",
        "Odstęp pomiędzy elementami": "Gap between elements",
        "Odwrócenie": "Invert",
        "Odziedzoczono po": "Inherited from",
        "Offset x": "Offset x",
        "Offset Y": "Offset Y",
        "Opcje": "Options",
        "Opis dla open graph": "Open Graph description",
        "Opis strony": "Page description",
        "Opóźnienie (ms)": "Delay (ms)",
        "Ostatnie kolory": "Recent colors",
        "Otwórz": "Open",
        "Padający cień": "Drop shadow",
        "Padding": "Padding",
        "Page builder": "Page builder",
        "Page Builder": "Page Builder",
        "Paragraf": "Paragraph",
        "Parzysty element": "Even element",
        "Pasek progresu": "Progress bar",
        "Podaj szerokość w px": "Enter width in px",
        "Podany kod jest niepoprawny, w konsoli znajdują się informacje o błędach": "Provided code is invalid, error details are available in console",
        "Podgląd": "Preview",
        "Podkreślenie": "Underline",
        "Podpowiedź": "Tooltip",
        "Pogrubienie": "Bold",
        "Pojedyńcza kolumna": "Single column",
        "Pokaż etykietę": "Show label",
        "pokaż więcej...": "show more...",
        "Polski": "Polish",
        "Położenie": "Placement",
        "Pomoc": "Help",
        "Poprzedni slajd": "Previous slide",
        "Powiększenie": "Zoom in",
        "Powrót": "back",
        "Powrzarzanie tła": "Background repeat",
        "Powtarzaj": "Repeat",
        "Powtarzaj horyzontalnie": "Repeat horizontally",
        "Powtarzaj wertykalnie": "Repeat vertically",
        "Pozycja": "Position",
        "Pozycja tła": "Background position",
        "Prawy": "Right",
        "Prawy dolny": "Bottom right",
        "Prawy dolny róg": "Bottom right corner",
        "Prawy górny": "Top right",
        "Prawy górny róg": "Top right corner",
        "Prezentacja": "Presentation",
        "Prosty": "Simple",
        "Przejdź wyżej": "Move up",
        "Przekierowanie": "Redirect",
        "Przekreślenie": "Strikethrough",
        "Przełącz edycję styli klas": "Toggle class style edit",
        "Przełącz obramowanie": "Toggle border",
        "Przełącz rozwinięcie": "Toggle expand",
        "Przesunięcie": "Offset",
        "Przesunięcie w dół": "Move down",
        "Przesunięcie w górę": "Move up",
        "Przesunięcie w lewo": "Move left",
        "Przesunięcie w prawo": "Move right",
        "Przeźroczystość": "Opacity",
        "Przycisk": "Button",
        "Przykładowy tekst": "Sample text",
        "Przypnij do lewej krawędzi": "Pin to left edge",
        "Przypnij do prawej krawędzi": "Pin to right edge",
        "Przywróć": "Restore",
        "Radio": "Radio",
        "React": "React",
        "Relatywne": "Relative",
        "Resetuj wymiary": "Reset dimensions",
        "Rozbudowany": "Advanced",
        "Rozbuduj tekst": "Expand text",
        "Rozciągnij": "Stretch",
        "Rozmiar": "Size",
        "Rozmiar strzałek": "Arrow size",
        "Rozmiar tekstu": "Text size",
        "Rozmycie": "Blur",
        "Rozstaw liter": "Letter spacing",
        "Równe odstępy": "Equal spacing",
        "Saturacja": "Saturation",
        "Schowaj": "Hide",
        "Sekcja": "Section",
        "Selektor kolorów": "Color picker",
        "SEO": "SEO",
        "Separator": "Separator",
        "Sepia": "Sepia",
        "SFC": "SFC",
        "Sformatuj poprawnie nazwę klasy": "Format class name correctly",
        "Skala szarości": "Grayscale",
        "Skrypt": "Script",
        "Skrypt aktywny": "Active script",
        "Skrypty": "Scripts",
        "Slajd": "Slide",
        "Slajder": "Slider",
        "Spread": "Spread",
        "Stan": "State",
        "Stan elementu": "Element state",
        "Statyczne": "Static",
        "Strzałki poza slajderem": "Arrows outside slider",
        "Styl": "Style",
        "Styl obramowania": "Border style",
        "Styl tekstu": "Text style",
        "Style": "Styles",
        "Style nie mogą być puste": "Styles cannot be empty",
        "Style tekstu": "Text styles",
        "Szablon": "Template",
        "Szablon aktywny": "Active template",
        "Szablon nie został pobrany": "Template has not been fetched",
        "Szablon nie został usunięty": "Template has not been deleted",
        "Szablon nie został zapisany": "Template has not been saved",
        "Szablon został usunięty": "Template has been deleted",
        "Szablon został zapisany": "Template has been saved",
        "Szerokość": "Width",
        "Szerokość ekranu (px)": "Screen width (px)",
        "Środek dolnej krawędzi": "Bottom center",
        "Środek górnej krawędzi": "Top center",
        "Środek kontenera": "Container center",
        "Środek lewej krawędzi": "Left center",
        "Środek prawej krawędzi": "Right center",
        "Tablet": "Tablet",
        "Target": "Target",
        "Tekst": "Text",
        "Tekst alternatywny": "Alt text",
        "Telefon": "Phone",
        "Tło": "Background",
        "Tłumaczenie": "Translation",
        "Transformacja": "Transform",
        "Tryb układu": "Layout mode",
        "Twoje imie": "Your name",
        "Twój adres email": "Your email address",
        "Typ": "Type",
        "Typ listy": "List type",
        "Typ nagłówka": "Heading type",
        "Typ przycisku": "Button type",
        "Tytuł": "Title",
        "Tytuł dla open graph": "Open Graph title",
        "Tytuł strony": "Page title",
        "Układ": "Layout",
        "Ułożenie elementów": "Element arrangement",
        "Ułożenie elementów według głównej osi": "Element arrangement along main axis",
        "Ułożenie elementów według osi poprzecznej": "Element arrangement along cross axis",
        "Usuń": "Delete",
        "Usuń urządzenie": "Delete device",
        "Utwórz": "Create",
        "Użyj styli zgodnych z CSS3": "Use CSS3-compatible styles",
        "W pionie": "Vertical",
        "W poziomie": "Horizontal",
        "Warstwy": "Layers",
        "Wartość": "Value",
        "Wartość koloru jest wymagana": "Color value is required",
        "Wartość w pikselach": "Value in pixels",
        "Wewnętrzny": "Inner",
        "Widoczność": "Visibility",
        "Wielka litera": "Uppercase",
        "Wiersz": "Row",
        "Wiersze": "Rows",
        "Własne": "Custom",
        "Własne polecenie": "Custom command",
        "Własny blok": "Custom block",
        "Własny kod CSS": "Custom CSS code",
        "Własny kod HTML": "Custom HTML code",
        "Własny kod JavaScript": "Custom JavaScript code",
        "Własny kod React": "Custom React code",
        "Własny kod Vue": "Custom Vue code",
        "Włącz pełny ekran": "Enable fullscreen",
        "Wpisywanie tekstu": "Typing text",
        "Wpisz polecenie": "Enter command",
        "Wpisz tutaj cytat": "Enter quote here",
        "Wpisz tutaj swój nagłówek": "Enter your heading here",
        "Wpisz tutaj tekst": "Enter text here",
        "Wprowadź modyfikację": "Enter modification",
        "Wrapper": "Wrapper",
        "Wszystko": "All",
        "Wybierz czcionki": "Select fonts",
        "Wycentrowanie": "Center alignment",
        "Wycisz film": "Mute video",
        "Wyczyszczenie formularza formularza": "Form form clearing",
        "Wyczyść": "Clear",
        "Wyczyść formularz": "Clear form",
        "Wygenerowany tekst": "Generated text",
        "Wygląd listy": "List appearance",
        "Wymagany": "Required",
        "Wymiary dokumentu": "Document dimensions",
        "Wyrównanie do końca": "Align end",
        "Wyrównanie do początku": "Align start",
        "Wyrównanie tekstu": "Text alignment",
        "Wysokość": "Height",
        "Wysokość linii": "Line height",
        "Wystąpił błąd podczas zapisywania kodu CSS": "An error occurred while saving CSS code",
        "Wystąpił błąd podczas zapisywania kodu HTML": "An error occurred while saving HTML code",
        "Wystąpił błąd podczas zapisywania kodu JavaScript": "An error occurred while saving JavaScript code",
        "Wystąpił błąd podczas zapisywania komponentu React": "An error occurred while saving React component",
        "Wyszukaj": "Search",
        "Wyśrodkowanie": "Center",
        "Wyświetl kod": "Display code",
        "YouTube": "YouTube",
        "Zaawansowany": "Advanced",
        "Zablokuj": "Lock",
        "Zaktualizuj": "Update",
        "Zamknij": "Close",
        "Zanikanie": "Fade",
        "Zaokgrąglenie rogów": "Corner radius",
        "Zapętlaj": "Loop",
        "Zapisywanie formularza": "Form saving",
        "Zapisz": "Save",
        "Zapisz formularz": "Save form",
        "Zarządzaj urządzeniami": "Manage devices",
        "Zawijaj": "Wrap",
        "Zawijanie elementow": "Element wrapping",
        "Zaznacz komponent aby edytować animacje": "Select component to edit animations",
        "Zaznaczony": "Selected",
        "Zaznaczony tekst": "Selected text",
        "Zdjęcie": "Image",
        "Zdjęcie dla open graph": "Open Graph image",
        "Zewnętrzny": "Outer",
        "Zmień nazwę": "Rename",
        "Zmień rozmiary": "Change sizes",
        "Zmień wymiary dokumentu": "Change document dimensions",
        "Zoom": "Zoom",
        "Zwykły przycisk": "Regular button"
    }
};
